import type { Component } from "vue";

import {
  BoardViewIcon,
  CalendarViewIcon,
  ListViewIcon,
  RoadmapViewIcon,
  SubtasksFlatIcon,
  SubtasksIndentedIcon,
  WorkflowViewIcon,
} from "~/icons";
import { LayoutKind, SubtaskDisplayMode } from "~/shared/enums";

export const LAYOUT_KIND_TO_NAME_AND_ICON = new Map<LayoutKind, [string, Component]>([
  [LayoutKind.LIST, ["List", ListViewIcon]],
  [LayoutKind.BOARD, ["Board", BoardViewIcon]],
  [LayoutKind.WORKFLOW, ["Workflow", WorkflowViewIcon]],
  [LayoutKind.CALENDAR, ["Calendar", CalendarViewIcon]],
  [LayoutKind.ROADMAP, ["Roadmap", RoadmapViewIcon]],
]);

const orderedLayoutKinds = [...LAYOUT_KIND_TO_NAME_AND_ICON.keys()];

export const LAYOUT_KIND_TO_NEXT_LAYOUT_KIND = new Map<LayoutKind, LayoutKind>(
  orderedLayoutKinds.map((layoutKind, index) => [
    layoutKind,
    orderedLayoutKinds[(index + 1) % orderedLayoutKinds.length],
  ])
);

export const LAYOUT_KIND_TO_PREVIOUS_LAYOUT_KIND = new Map<LayoutKind, LayoutKind>(
  orderedLayoutKinds.map((layoutKind, index) => [
    layoutKind,
    orderedLayoutKinds[(index - 1 + orderedLayoutKinds.length) % orderedLayoutKinds.length],
  ])
);

export const SUBTASK_DISPLAY_MODES_TO_NAME_AND_ICON = new Map<SubtaskDisplayMode, [string, Component]>([
  [SubtaskDisplayMode.INDENTED, ["Indented", SubtasksIndentedIcon]],
  [SubtaskDisplayMode.FLAT, ["Flat", SubtasksFlatIcon]],
]);

export const GROUP_BY_LAYOUT_KINDS = new Set([LayoutKind.BOARD, LayoutKind.LIST]);
export const COLOR_BY_LAYOUT_KINDS = new Set([LayoutKind.CALENDAR, LayoutKind.ROADMAP]);
